// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4f7821c4379b2aabacda9649a9b2741bb2180676.chunk.js";
};